import { render, staticRenderFns } from "./StaticContentEdit.vue?vue&type=template&id=2f1fbfd6&scoped=true"
import script from "./StaticContentEdit.vue?vue&type=script&lang=js"
export * from "./StaticContentEdit.vue?vue&type=script&lang=js"
import style0 from "./StaticContentEdit.vue?vue&type=style&index=0&id=2f1fbfd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1fbfd6",
  null
  
)

export default component.exports